import { create } from 'zustand';

const useCommunicationProviderStore = create((set) => ({
    // List state
    communicationProviders: [],
    loading: false,
    testingId: null,
    error: null,

    paginationData: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
    },

    columnFilters: {},
    uniqueValues: {},

    // UI state
    selectedProvider: null,
    isFormOpen: false,
    isEditMode: false,
    isDeleteDialogOpen: false,
    providerToDelete: null,

    // Setters
    setCommunicationProviders: (communicationProviders) => set({ communicationProviders }),
    setPagination: (paginationData) => set((state) => ({
        paginationData: { ...state.paginationData, ...paginationData },
    })),
    setLoading: (loading) => set({ loading }),
    setTestingId: (testingId) => set({ testingId }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setColumnFilters: (filters) => set((state) => ({
        columnFilters: typeof filters === 'function' ? filters(state.columnFilters) : filters,
    })),
    setUniqueValues: (values) => set((state) => ({
        uniqueValues: { ...state.uniqueValues, ...values },
    })),

    // Form actions
    openCreateForm: () => set({ isFormOpen: true, isEditMode: false, selectedProvider: null }),
    openEditForm: (provider) => set({ isFormOpen: true, isEditMode: true, selectedProvider: provider }),
    closeForm: () => set({ isFormOpen: false, isEditMode: false, selectedProvider: null }),

    // Delete dialog
    openDeleteDialog: (provider) => set({ isDeleteDialogOpen: true, providerToDelete: provider }),
    closeDeleteDialog: () => set({ isDeleteDialogOpen: false, providerToDelete: null }),

    reset: () => set({
        communicationProviders: [],
        loading: false,
        testingId: null,
        error: null,
        columnFilters: {},
        selectedProvider: null,
        isFormOpen: false,
        isDeleteDialogOpen: false,
    }),
}));

export { useCommunicationProviderStore };
export default useCommunicationProviderStore;
